import { Stack } from '@zoopla-eng/zds/stack';
import { ToggleGroup } from '@zoopla-eng/zds/toggles';
import { itemStyle } from './Modal.styles.css';

type OptionalBoolean = '' | 'true' | 'false';
type TriState = 'only' | 'include' | 'exclude';

export type NewHomes = '' | TriState;
export type IsRetirementHome = OptionalBoolean;
export type IsSharedOwnership = OptionalBoolean;
export type IsAuction = OptionalBoolean;

type HomeType = {
    newHomes: NewHomes;
    isRetirementHome: IsRetirementHome;
    isSharedOwnership: IsSharedOwnership;
    isAuction: IsAuction;
};

type HomeTypeProps = {
    value: HomeType;
    onChange: (homeType: HomeType) => void;
};

function mapToToggleGroup(value: OptionalBoolean) {
    const options: {
        [key: string]: TriState;
    } = {
        '': 'include',
        true: 'only',
        false: 'exclude'
    };

    return options[value];
}

function mapToFormValue(value: TriState): OptionalBoolean {
    const options: {
        [key: string]: OptionalBoolean;
    } = {
        include: '',
        only: 'true',
        exclude: 'false'
    };

    return options[value];
}

export const HomeType = ({ value, onChange }: HomeTypeProps) => {
    return (
        <Stack rowGap="S400" {...{ whiteSpace: 'nowrap' }}>
            <Stack
                flexDirection="row"
                flexWrap="wrap"
                // columnGap="0"
                rowGap="S400"
                alignItems="center"
                justifyContent="space-between"
            >
                <div className={itemStyle}>
                    <p>New homes</p>
                </div>
                <div className={itemStyle}>
                    <ToggleGroup
                        label="New homes"
                        value={value.newHomes}
                        items={[
                            {
                                id: 'new_homes_include',
                                value: 'include',
                                label: 'Include'
                            },
                            {
                                id: 'new_homes_exclude',
                                value: 'exclude',
                                label: 'Exclude'
                            },
                            {
                                id: 'new_homes_only',
                                value: 'only',
                                label: 'Show only'
                            }
                        ]}
                        onValueChange={(newHomesValue) => {
                            onChange({
                                ...value,
                                newHomes: newHomesValue
                            });
                        }}
                    />
                </div>
            </Stack>
            <Stack
                flexDirection="row"
                flexWrap="wrap"
                // columnGap="0"
                rowGap="S400"
                alignItems="center"
                justifyContent="space-between"
            >
                <div className={itemStyle}>
                    <p>Retirement homes</p>
                </div>
                <div className={itemStyle}>
                    <ToggleGroup
                        label="Retirement homes"
                        value={mapToToggleGroup(value.isRetirementHome)}
                        items={[
                            {
                                id: 'retirement_homes_include',
                                value: 'include',
                                label: 'Include'
                            },
                            {
                                id: 'retirement_homes_exclude',
                                value: 'exclude',
                                label: 'Exclude'
                            },
                            {
                                id: 'retirement_homes_only',
                                value: 'only',
                                label: 'Show only'
                            }
                        ]}
                        onValueChange={(isRetirementHomeValue) => {
                            onChange({
                                ...value,
                                isRetirementHome: mapToFormValue(
                                    isRetirementHomeValue
                                )
                            });
                        }}
                    />
                </div>
            </Stack>
            <Stack
                flexDirection="row"
                flexWrap="wrap"
                // columnGap="0"
                rowGap="S400"
                alignItems="center"
                justifyContent="space-between"
            >
                <div className={itemStyle}>
                    <p>Shared ownership</p>
                </div>
                <div className={itemStyle}>
                    <ToggleGroup
                        label="Shared ownership"
                        value={mapToToggleGroup(value.isSharedOwnership)}
                        items={[
                            {
                                id: 'shared_ownership_include',
                                value: 'include',
                                label: 'Include'
                            },
                            {
                                id: 'shared_ownership_exclude',
                                value: 'exclude',
                                label: 'Exclude'
                            },
                            {
                                id: 'shared_ownership_only',
                                value: 'only',
                                label: 'Show only'
                            }
                        ]}
                        onValueChange={(isSharedOwnershipValue) => {
                            onChange({
                                ...value,
                                isSharedOwnership: mapToFormValue(
                                    isSharedOwnershipValue
                                )
                            });
                        }}
                    />
                </div>
            </Stack>
            <Stack
                flexDirection="row"
                flexWrap="wrap"
                // columnGap="0"
                rowGap="S400"
                alignItems="center"
                justifyContent="space-between"
            >
                <div className={itemStyle}>
                    <p>Auction</p>
                </div>
                <div className={itemStyle}>
                    <ToggleGroup
                        label="Auction"
                        value={mapToToggleGroup(value.isAuction)}
                        items={[
                            {
                                id: 'auction_include',
                                value: 'include',
                                label: 'Include'
                            },
                            {
                                id: 'auction_exclude',
                                value: 'exclude',
                                label: 'Exclude'
                            },
                            {
                                id: 'auction_only',
                                value: 'only',
                                label: 'Show only'
                            }
                        ]}
                        onValueChange={(isAuctionValue) => {
                            onChange({
                                ...value,
                                isAuction: mapToFormValue(isAuctionValue)
                            });
                        }}
                    />
                </div>
            </Stack>
        </Stack>
    );
};
